import LayoutCustom from './LayoutCustom';

export default LayoutCustom;
